import React, { Component } from 'react';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import { Button } from '../util'

import './Dashboard.css'
import 'react-datepicker/dist/react-datepicker.css';
import '../App.css';

/**
 * @prop diaryRequest, openDashboardHandler, date
 */
export default class Timeline extends React.Component {

		constructor (props) {
				super(props);

				this.state = {
						date: props.date,
				}

				this.search = this.search.bind(this);
		}

		componentDidMount () {
				window.addEventListener("scroll", () => {
						const body = document.body,
									html = document.documentElement;

						const height = Math.max( body.scrollHeight, body.offsetHeight, 
																		 html.clientHeight, html.scrollHeight, html.offsetHeight );

						const scrollDistanceFromBottom = height-(window.scrollY+parseInt(window.innerHeight));
						if (scrollDistanceFromBottom < 10) {
								this.retrieve(this.state.date.add('1', 'days'));
//								console.log(this.state.date.add('1', 'days'));
						} 
				});
		}

		retrieve(date) {
				const key = date.format('YYYY-MM-DD').substr(0, 10);
				console.log('retrieve '+key);
				const data = JSON.parse(localStorage.diary_posts);
				if (!data[key]) return false;

				return (
								<div>
								<pre className="diary-viewer" style={{fontSize: "18px"}}>
								<h3>{key}</h3>
								{data[key]}
						</pre>
								</div>
				);
		}

		search() {
				const needle = document.getElementById('needle').value;

				if (needle.match(/^\d{4}-\d{2}-\d{2}$/)) {
						// search by date
						const res = needle.match(/^(\d{4})-(\d{2})-(\d{2})$/);
						let tmp = moment().
								year(Number(res[1])).
								month(Number(res[2])-1).
								date(Number(res[3]));
//						console.log(tmp);
						this.setState({ date: tmp });
				} else {
						// set by keyword
						// TODO
				}
		}


		render() {
				let diaries = [];
				for (let i = 0; i < 10; i++) {
						diaries.push(this.retrieve(this.state.date));
						this.state.date.add('1', 'days');
				}
				
				return (
								<div>
								<header className="App-header">
								<div id="logo">
								<div onClick={this.props.openDashboardHandler}>
								<h1 style={{fontSize: '2.3em', position: 'relative', bottom: '.8em', textShadow: 'none'}}>Diary</h1>
								</div>
								</div> 
								</header>
								
								<article>
								<p className="lead">Timeline</p>
								<input id="needle" type="text" />
								<Button value="search" onClick={this.search} />

						{diaries}
						</article>
								</div>
				);
		}
}



// WEBPACK FOOTER //
// ./src/page/Timeline.js